<template>
  <div id="alerta-tie" v-if="show" ref="tie">
    <div id="tie" ref="tie" :class="tieBorderClass">
      <div class="container">
        <div class="uc-alert" :class="tieClass">
          <div class="uc-alert_content">
            <i class="uc-icon icon-size--sm">{{ icon }}</i>
            <span class="p p-size--sm bold my-8">{{ text }}</span>
            <span>
              <a class="text-size--sm" :href="buttonUrl" :target="target">{{
                buttonTitle
              }}</a>
            </span>
          </div>
          <div
            v-show="closeable === '1'"
            @click="close()"
            class="uc-alert_close ml-12"
            style="cursor: pointer; align-self: flex-start"
          >
            <i class="uc-icon">close</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#tie {
  position: fixed;
  background: white;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.3);
  left: 0;
  right: 0;
  z-index: 20;
}
.tie-border-info {
  border-top: 3px solid #0176de;
}
.tie-border-warning {
  border-top: 3px solid #fec60d;
}
.tie-border-error {
  border-top: 3px solid #f24f4f;
}
</style>
<script>
export default {
  props: [
    "text",
    "type",
    "buttonType",
    "buttonTitle",
    "buttonUrl",
    "closeable",
  ],
  data: function () {
    return {
      calculatedHeight: 40,
      show: true,
    };
  },
  computed: {
    target: function () {
      if (this.buttonType === "3") {
        return "_blank";
      }
      return "_self";
    },
    tieBorderClass: function () {
      if (this.type === "1") {
        return "tie-border-info";
      }
      if (this.type === "2") {
        return "tie-border-warning";
      }
      if (this.type === "3") {
        return "tie-border-error";
      }
    },
    tieClass: function () {
      if (this.type === "1") {
        return "tie-info";
      }
      if (this.type === "2") {
        return "tie-warning";
      }
      if (this.type === "3") {
        return "tie-error";
      }
    },
    icon: function () {
      if (this.type === "1") {
        return "check_circle";
      }
      if (this.type === "2") {
        return "warning";
      }
      if (this.type === "3") {
        return "cancel";
      }
    },
  },
  methods: {
    close: function () {
      this.show = false;
      window.document.documentElement.style.setProperty("--tie-height", "0px");
    },
    calculateHeight() {
      this.calculatedHeight = this.$refs.tie.offsetHeight;
      window.document.documentElement.style.setProperty(
        "--tie-height",
        this.calculatedHeight + "px"
      );
    },
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener("resize", this.calculateHeight);

    window.document.documentElement.style.setProperty(
      "--tie-height",
      this.$refs.tie.offsetHeight + "px"
    );
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateHeight);
    window.document.documentElement.style.setProperty("--tie-height", "0px");
  },
};
</script>
